import type { Product, ProductVariant } from '../types';

/** First variant that has a real image, else the first variant. */
export function primaryVariant(product: Product): ProductVariant {
  return product.variants.find((v) => v.image) ?? product.variants[0];
}

export function primaryImage(product: Product): string | null {
  return primaryVariant(product)?.image ?? null;
}

/** Descriptive alt text for a product/variant image. */
export function productImageAlt(product: Product, variant?: ProductVariant): string {
  const size = variant?.packSize ? `${variant.packSize} pack` : '';
  return `${product.name} — ${product.tagline}${size ? `, ${size}` : ''} by GreenbayBio`.trim();
}
